import { isLoggedIn, suspendedAccount } from '../../requests/loader';
import store from '../../store';
import Utils, {getSuspendedAccountLabels}  from '../Utils';
import utilsIsSticky from '../../utils/user/IsSticky';
import AAF from 'src/AAF/AAF';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY } from "../../AAFPlayer/constants";
import {AAF_MODAL_SUSPENDED_ACCOUNT, HIDE_MODAL, showModal} from 'src/actions/modal';


class UtilsIsLoggedIn {
  constructor() {

    this.default = 24;
    this.defaultSuspendedAccount = 1;
    this.isLoggedInInterval = null;
    this.suspendedAccountInInterval = null;
    this.intervaltime = null;
    this.intervaltimeSuspendedAccount = null;
    this.intervalValidatorTimer = null;
    this.intervalSuspendedAccount = null;

    this.setIntervalIsLoggedIn = this.setIntervalIsLoggedIn.bind(this);
    this.setIntervalValidatorTimer = this.setIntervalValidatorTimer.bind(this);
    this.setIntervalSuspendedAccount = this.setIntervalSuspendedAccount.bind(this)

  }

  setIntervalIsLoggedIn(history) {
    let hours = null;

    if (!this.intervaltime) {
      try {
        hours = parseFloat(Utils.getAPARegionalized('isloggedin_refresh_hours_time', 'hour_refresh', this.default));

      } catch (e) {
        hours = this.default;
      }
      this.intervaltime = hours * 60 * 60 * 1000;
    }

    if (this.isLoggedInInterval) {
      clearInterval(this.isLoggedInInterval);
      this.isLoggedInInterval = null;
    }

    this.isLoggedInInterval = setInterval(() => {
      return isLoggedIn()
        .then(result => {
          const user = result.response ? result.response : {};
          AAF.Resilence.filterIsloggedin(result, 'Interval', history);
        }).catch((err) => {
          console.error('isLoggedIn failed when interval, user NOT logged in', err);
          // Se deja como estaba en ott
          AAF.Resilence.filterIsloggedin(null, 'Interval', history);
        });
    }, this.intervaltime);
  }

  setIntervalValidatorTimer(){

    const {user: {isLoggedIn : isUserLoggedIn, userDetectWS} = {}} = store.getState();

    if (!isUserLoggedIn || !Utils.isNullOrUndefined(userDetectWS)) {
      return;
    }

    const settings = this.getValidatorTimerSetting();

    if (settings.enable){

      const msInterval = settings.time * 60 * 1000;
      if (this.intervalValidatorTimer){
        clearInterval(this.intervalValidatorTimer);
        this.intervalValidatorTimer = null;
      }

      this.intervalValidatorTimer = setInterval(() => {
        return isLoggedIn()
        .then(result => {
          const {response : {is_user_logged_in : isLoggedin, userDetectWS} = {}} = result;
        if (!isLoggedin){
            this.logout();
          }
        });
      }, msInterval );

    }
  }

  setIntervalSuspendedAccount() {

    let hours = null;

    if (!this.intervaltimeSuspendedAccount) {
      try {
        hours = parseFloat(Utils.getAPARegionalized('suspended_refresh_hours_time', 'hour_refresh', this.defaultSuspendedAccount));

      } catch (e) {
        hours = this.defaultSuspendedAccount;
      }
      this.intervaltimeSuspendedAccount = hours * 60 * 60 * 1000;

    }

    if (this.suspendedAccountInInterval) {
      clearInterval(this.suspendedAccountInInterval);
      this.suspendedAccountInInterval = null;
    }

    this.suspendedAccountInInterval = setInterval(() => {


      const {user: {parent_id} = {}} = store.getState();

      const params = {
        user_id: parent_id
      }
      return suspendedAccount(params)
        .then(result => {
          const account = result.response ? result.response : {};
          const {isSuspended = false} = account;
          if(isSuspended){
            if (Utils.modalType() !== AAF_MODAL_SUSPENDED_ACCOUNT) {
              this.setIntervalSuspendedAccount();
              const modal = {
                modalType: AAF_MODAL_SUSPENDED_ACCOUNT,
                modalProps: { buttonsAlign: 'vertical' , ...getSuspendedAccountLabels()}
              };

              store.dispatch(showModal(modal))
            }
          } else {
            if (Utils.modalType() === AAF_MODAL_SUSPENDED_ACCOUNT) {
              window.location.assign('/');
            }
          }
        }).catch((err) => {
          if (Utils.modalType() === AAF_MODAL_SUSPENDED_ACCOUNT) {
            window.location.assign('/');
          }
        });
    }, this.intervaltimeSuspendedAccount);
  }
  
  hideModal(){
    store.dispatch({
      type: HIDE_MODAL,
  });
  }

  logout(){
    utilsIsSticky.isStickyLogout();
  }

  getValidatorTimerSetting(){
    return Utils.getApaMetadataKey('session_validation_timer', '{"enable":false, "time": 240}');
  }

  showBlueHeadBand() {
    const {user} = store.getState() || {};
    if (Utils.isPTV(user) || user.validEmail){
      return false;
    }
    else {
      const {limit = 0} = Utils.getApaMetadataKey('user_mail_validation', '{"enable":false,"limit":3}') || {};
      return user.counterValidEmail <= limit;
    }
  }

  userType() {
    const {user} = store.getState() || {};
    if (Utils.isPTV(user)){
      return true;
    } else return false;
  }

  userHasSuscriptions() {
    const {user} = store.getState() || {};
    return user.isSusc || (user.subscriptions && Object.keys(user.subscriptions).length > 0);
  }
}

const instanceUtilsIsLoggedIn = new UtilsIsLoggedIn();
//Object.freeze(instance);

export default instanceUtilsIsLoggedIn;


// WEBPACK FOOTER //
// ./src/utils/user/isLoggedIn.js